(() => {
  const modal = document.getElementById('image-zoom-modal');
  const modalImg = document.getElementById('image-zoom-target');
  const closeBtn = modal?.querySelector('.image-zoom-close');
  let prevFocus = null;

  const open = (src, alt='') => {
    if (!modal || !modalImg) return;
    modalImg.src = src;
    modalImg.alt = alt;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
    prevFocus = document.activeElement;
    closeBtn?.focus();
  };

  const close = () => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
    modalImg.removeAttribute('src');
    prevFocus?.focus?.();
  };

  document.addEventListener('click', (e) => {
    // 1) Explicit triggers (if you ever add data-zoom-src or .js-zoomable elsewhere)
    const explicit = e.target.closest('[data-zoom-src], .js-zoomable');
    if (explicit) {
      e.preventDefault();
      const src = explicit.dataset.zoomSrc || explicit.currentSrc || explicit.src;
      const alt = explicit.alt || '';
      if (src) open(src, alt);
      return;
    }

    // 2) Theme-editor Link field trigger (no code changes in the image block)
    const a = e.target.closest('a[href]');
    if (!a) return;

    // Only hijack links that wrap an image/picture (to avoid interfering with normal links)
    const wrapsImage = a.querySelector('img, picture') || e.target.tagName === 'IMG';
    if (!wrapsImage) return;

    const url = new URL(a.href, location.href);
    const isImageFile = /\.(png|jpe?g|webp|gif|avif|svg)(\?.*)?$/i.test(url.pathname);
    const isShopifyCDN = /cdn\.shopify(?:cdn)?\.com|shopifycloud\.com/i.test(url.hostname);
    const hasZoomFlag = url.hash.toLowerCase() === '#zoom' || url.searchParams.get('zoom') === '1';

    if (hasZoomFlag || (isImageFile && isShopifyCDN)) {
      e.preventDefault();
      // strip the zoom marker if present
      const cleanHref = a.href.replace(/(#zoom$)/i, '').replace(/[?&]zoom=1(&|$)/, (m, g1) => g1 ? '?' : '');
      // Try to use the clicked image's alt if available
      const imgEl = a.querySelector('img');
      const alt = imgEl?.alt || '';
      open(cleanHref, alt);
    }
  });

  modal?.addEventListener('click', (e) => {
    if (e.target === modal || e.target === closeBtn) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal?.classList.contains('is-open')) close();
  });
})();
